//export const SUNFLOWER_URL='http://localhost:9080'

//fontsize in the components
export const TEXT_FONT_SIZE = 14
export const TOC_FONT_SIZE = "0.8em"
export const LOF_FONT_SIZE = "0.8em"

export const APP_NAME =  "Effigy Semantic Browser"
